<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container
    [observables]="[invoices$, process$, chargeNumbers$]"
></ef-loading-container>
<div class="card" fullscreen>
    <p-accordion [multiple]="true" (activeIndexChange)="handleOnOpen($event)">
        <p-accordionTab [(selected)]="activeState[0]" header="Contract">
            <div [ngStyle]="{ height: tabHeight }">
                <div class="flex items-center">
                    <p-checkbox
                        #chkShowAllContracts
                        class="ef-checkbox"
                        binary="true"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Include Inactive Contracts"
                        (onChange)="showAllContractsChecked($event)"
                        [(ngModel)]="showInactiveContracts"
                    ></p-checkbox>
                    <label class="ml-2">Include Inactive Contracts</label>
                </div>
                <div class="invoice-cycle">
                    <ef-invoice-cycle
                        [items]="contracts$ | async"
                        [invoiceCycle]="invoiceCycle$ | async"
                        [invoiceCycleDaysSelectItems]="
                            invoiceCycleDaysSelectItems$ | async
                        "
                        [contractSelectItems]="contractSelectItems$ | async"
                        (SaveItem)="onSaveInvoiceCycle($event)"
                        (SelectItem)="onSelectInvoiceCycle($event)"
                        (ResetContract)="resetInvoiceContract.next($event)"
                    ></ef-invoice-cycle>
                </div>
            </div>
        </p-accordionTab>
        <p-accordionTab [(selected)]="activeState[1]">
            <ng-template #header>
                <span *ngIf="!!selectedInvoiceContractCycleModel"
                    >{{ selectedInvoiceContractCycleModel.ContractDesc }} -
                    Invoice schedule {{ startDate | date: 'MM/dd/yyyy' }} -
                    {{ endDate | date: 'MM/dd/yyyy' }}</span
                >
            </ng-template>
            <div [ngStyle]="{ height: tabHeight }">
                <form [formGroup]="filterFormGroup" #filterForm="ngForm" id="filterForm">
                    <p-toolbar>
                        <p-floatLabel variant="on">
                            <p-datepicker id="startDate" formControlName="startDate" appendTo="body" [yearNavigator]="true"
                                [yearRange]="this.yearRange" [(ngModel)]="startDate" (ngModelChange)="datesChanged()"></p-datepicker>
                            <label for="float-dd">Start Date</label>
                        </p-floatLabel>
                        <p-floatLabel variant="on">
                            <p-datepicker formControlName="endDate" appendTo="body" [yearNavigator]="true" [yearRange]="this.yearRange"
                                [(ngModel)]="endDate" (ngModelChange)="datesChanged()" [minDate]="this.startDate"
                                [maxDate]="this.maxDate"></p-datepicker>
                            <label for="float-dd">End Date</label>
                        </p-floatLabel>
                        <p-floatLabel variant="on" *ngIf="false">
                            <p-multiSelect id="ddContract" formControlName="contractList" [(ngModel)]="selectedContracts"
                                [options]="contractsSelectItems$ | async" (ngModelChange)="filtersChanged()" appendTo="body"
                                maxSelectedLabels="1" placeholder="Contract"></p-multiSelect>
                            <label for="float-dd">Contract</label>
                        </p-floatLabel>
                        <div class="flex items-center">
                            <p-checkbox #chkInvoicesOnly class="ef-checkbox" binary="true" data-toggle="tooltip" data-placement="top"
                                title="Contracts with Invoices Only" (onChange)="showInvoicesOnlySubject.next($event.checked)"
                                [(ngModel)]="showInvoicesOnly" [ngModelOptions]="{ standalone: true }">
                            </p-checkbox>
                            <label class="ml-2">Contracts with Invoices Only</label>
                        </div>


                        <p-message *ngIf="false" severity="info"
                            text="A contract must be selected when the date range is greater than one year."></p-message>
                    </p-toolbar>

                </form>
                <div class="invoice-management">
                    <ef-invoice-management
                        [items]="invoices$ | async"
                        [invoiceCycle]="invoiceCycle$ | async"
                        [invoiceCycleDaysSelectItems]="
                            invoiceCycleDaysSelectItems$ | async
                        "
                        (SaveInvoiceSchedule)="onSaveInvoice($event)"
                        (SelectItem)="selectInvoiceSubject.next($event)"
                        (SaveInvoiceCycle)="onSaveInvoiceCycle($event)"
                    ></ef-invoice-management>
                </div>
            </div>
        </p-accordionTab>
        <p-accordionTab
            *ngIf="false"
            [(selected)]="activeState[2]"
            (selectedChange)="onSelectedChargeNumberTab($event)"
        >
            <ng-template #header>
                <span *ngIf="!!selectedInvoiceContractCycleModel">
                    {{ selectedInvoiceContractCycleModel.ContractDesc }} -
                    Charge Number activity for
                    {{ startDate | date: 'MM/dd/yyyy' }} -
                    {{ endDate | date: 'MM/dd/yyyy' }}
                </span>
            </ng-template>
            <div [ngStyle]="{ height: tabHeight }">
                <div class="flex items-center">
                    <p-checkbox
                        #chkShowAllContracts
                        class="ef-checkbox"
                        binary="true"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Include Inactive Charge Numbers"
                        (onChange)="showAllCNsChecked($event)"
                        [(ngModel)]="showInactiveChargeNumbers"
                    ></p-checkbox>
                    <label class="ml-2">Include Inactive Charge Numbers</label>
                </div>
                <div class="invoice-charge-number">
                    <ef-invoice-charge-number
                        [items]="chargeNumbers$ | async"
                    ></ef-invoice-charge-number>
                </div>
            </div>
        </p-accordionTab>
    </p-accordion>
</div>
